import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import BusinessSection from "./components/BusinessSection";
import CompetitiveSection from "./components/CompetitiveSection";
import VietnamSection from "./components/VietnamSection";
import VisionSection from "./components/VisionSection";
import InquirySection from "./components/InquirySection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  useScrollAnimation();

  return (
    <div className="flex flex-col">
      <HeroSection />
      <AboutSection />
      <BusinessSection />
      <CompetitiveSection />
      <VietnamSection />
      <VisionSection />
      <InquirySection />
      <ContactSection />
    </div>
  );
}
